import React from 'react';
import PropTypes from 'prop-types';
import Multiselect from 'react-widgets/Multiselect';
import MultiValueField from './MultiValueField';

/**
 * Drop-in replacement for react-widgets Multiselect in filters:
 * the same props, but collapsed to one line ("… +N") until clicked, with apply / cancel (Jira-like).
 * Cancel calls onChange with the values the editor was opened with.
 */
// filter: typing filters the list - by default case-insensitive "contains" on the title
const CollapsibleMultiselect = ({ value, data, dataKey, valueField, textField, onChange, disabled, filter = 'contains', ...rest }) => {
    const key = valueField || dataKey || 'value';

    // disabled: the plain multiselect with the search icon on the right, as the empty editable field
    if (disabled === true) {
        return (
            <div className="multi-value multi-value--disabled">
            <Multiselect
                value={value}
                data={data}
                dataKey={dataKey}
                textField={textField}
                onChange={onChange}
                disabled={disabled}
                filter={filter}
                {...(valueField ? { valueField } : {})}
                {...rest}
            />
            <span className="multi-value__search-icon" aria-hidden="true"><i className="fa fa-search" /></span>
            </div>
        );
    }

    // titles for the collapsed view: values from the URL may hold only the value, take the title from `data`
    const getTitle = (item) => {
        const raw = item && typeof item === 'object' ? item[key] : item;
        const option = (data || []).find(opt => opt && typeof opt === 'object' && String(opt[key]) === String(raw));
        const source = option || item;
        let title;
        if (source && typeof source === 'object') {
            title = typeof textField === 'function' ? textField(source) : source[textField || 'title'];
        } else {
            title = source;
        }
        if (title === undefined || title === null || title === '') {
            title = raw;
        }
        return title === undefined || title === null ? '' : String(title);
    };

    const titles = (Array.isArray(value) ? value : []).map(getTitle).filter(Boolean);

    return (
        <MultiValueField
            titles={titles}
            value={value}
            onRestore={(snapshot) => { onChange && onChange(Array.isArray(snapshot) ? snapshot : [], { action: 'restore' }); }}
        >
            <Multiselect
                value={value}
                data={data}
                dataKey={dataKey}
                textField={textField}
                onChange={onChange}
                disabled={disabled}
                filter={filter}
                {...(valueField ? { valueField } : {})}
                {...rest}
            />
        </MultiValueField>
    );
};

CollapsibleMultiselect.propTypes = {
    value: PropTypes.any,
    data: PropTypes.array,
    dataKey: PropTypes.string,
    valueField: PropTypes.string,
    textField: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    onChange: PropTypes.func,
    disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.array])
};

export default CollapsibleMultiselect;
